import { ref } from 'vue';

export function useNightMode(options = {}) {
  const isNightMode = ref(false);

  const getIsNightMode = function () {
    return (window.isNightMode && window.isNightMode()) || false;
  };

  const NIGHT_ROOT_ID = 'oppo_night_root';

  const handler = function () {
    isNightMode.value = getIsNightMode();

    if (isNightMode.value) {
      document.documentElement.dataset.theme = 'dark';
      document.documentElement.classList.add(NIGHT_ROOT_ID);
    } else {
      document.documentElement.dataset.theme = 'day';
      document.documentElement.classList.remove(NIGHT_ROOT_ID);
    }
  };

  handler();

  document.addEventListener('nightmodechange', handler);

  return {
    isNightMode,
  };
}
